import React, {Component} from 'react';

export default class extends Component {
  static propTypes = {
    dateString: React.PropTypes.string,
  };

  render() {
    const {dateString} = this.props;
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-us', {month: 'short'});
    const year = date.getFullYear();

    return (
      <div>
        <span className="year">{year}</span>
        <span className="month">{month}</span>
        <span className="day">{day}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/UpcomingServices/FormatDate/index.js